<template>
  <v-card>
    <v-alert type="info" dense icon="fa-sms"
      >To Subscribers on Event: {{ compEventName }} ({{ compEventId }})
    </v-alert>
    <v-spacer></v-spacer>
    <v-form v-model="isValid">
      <v-textarea
        v-model="compSmsText"
        outlined
        rounded
        required
        prepend-inner-icon="fa-sms"
        placeholder="Sms text"
        :rules="smsRules"
        hint="Sms text"
        counter
        clearable
        clear-icon="mdi-close-circle"
      ></v-textarea>
      <!-- <v-alert type="info" dense dismissible>{{ compComment }}</v-alert> -->
      <v-row align="center" justify="space-around">
        <!-- <v-col justify="center"> -->
        <v-btn
          small
          color="primary"
          rounded
          @click="sendSms"
          :disabled="!isValid"
        >
          SUBMIT
          <v-icon small right>fa-sms</v-icon>
        </v-btn>

        <!-- </v-col> -->
        <!-- <v-col justify="center"> -->
        <v-btn small rounded color="primary" :to="{ name: 'BoxList' }"
          >Done</v-btn
        >
        <copybutton :tocopy="compSmsText"></copybutton>
        <!-- </v-col> -->
      </v-row>

      <v-row class="pa-4"><v-spacer></v-spacer></v-row>
      <v-chip small color="red" text-color="white" v-if="!boxOpenOrClose"
        >Only Submit SMS on Close if strictly necessary!<v-icon
          >fa-triangle-exclamation</v-icon
        ></v-chip
      >
    </v-form>
    <div>.</div>
    <v-alert type="success" :value="isAlertVisible" dense>
      {{ statusResultMsg }}
    </v-alert>
    <v-alert type="error" :value="isWarningAlertVisible" dense>
      {{ statusResultMsg }}
    </v-alert>
    <v-row><v-spacer></v-spacer>.</v-row>
    <ul v-if="errors && errors.length">
      <li v-for="error of errors" :key="error.id" style="color: Red">
        {{ error.message }}
      </li>
    </ul>
  </v-card>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import copybutton from "@/components/Copy.vue";

export default {
  name: "SendEventSms",
  props: {
    regId: Number,
    ac: String,
    selectedEventId: Number,
    selectedEventName: String,
    smsText: String,
    comment: String,
    boxOpenOrClose: Boolean,
  },
  data() {
    return {
      compEventId: this.selectedEventId,
      compEventName: this.selectedEventName,
      compSmsText: this.smsText,
      compComment: this.comment,
      compRegId: this.regId,
      compExecResponseText: this.execResponseText,
      smsRules: [(v) => !!v || "Text is required"],
      isAlertVisible: false,
      isWarningAlertVisible: false,
      errors: [],
      statuses: [],
      statusResult: Number,
      statusResultMsg: String,
      isValid: true,
    };
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    this.isValid = false;
  },
  methods: {
    //   closeComponent() {
    //       this.$emit("closeComponent", false);
    //   },
    sendSms() {
      var regId = this.compRegId;
      var msg = this.compSmsText;
      var eventId = this.compEventId;
      var ac = this.ac;
      var toSubmit = JSON.stringify({ msg, ac });
      const uri = this.baseUrl + "gwasmsevent/" + eventId + "/" + regId;
      // console.log("uriSms: ", uri);
      // console.log("toSubmitSms: ", toSubmit);
      this.isValid = false;
      this.postit(uri, toSubmit);
    },
    postit(uri, toSubmit) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          console.log("smsRespons", response.data);
          this.statusResult = response.data.Result;
          this.statusResultMsg = response.data.ResultMsg;
          if (this.statusResult == undefined || this.statusResult == null) {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
          }

          this.setAlert(this.statusResult);
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
  },
  components: {
    copybutton,
  },
};
</script>